import { useIsMobile } from "../../lib/useIsMobile";
import { useWorkspace } from "../../context/WorkspaceContext";
import { ErrorBoundary } from "../common/ErrorBoundary";
import { DesktopShell } from "./DesktopShell";
import { MobileShell } from "./MobileShell";

export default function AppShell() {
  const isMobile = useIsMobile();
  const { tabs, active } = useWorkspace();

  // Keep all open tabs mounted so state is preserved when switching (PrimeWork behavior).
  // Each tab is isolated in its own ErrorBoundary so a crash in one page never blanks the app.
  const content = tabs.map((t) => {
    const Comp = t.component;
    return (
      <div key={t.key} style={{ display: active === t.key ? "block" : "none" }}>
        <ErrorBoundary key={t.key}>
          <Comp />
        </ErrorBoundary>
      </div>
    );
  });

  return isMobile ? <MobileShell>{content}</MobileShell> : <DesktopShell>{content}</DesktopShell>;
}
